import useMediaView from "features/common/hooks/useMediaView";
import React from "react";
import NoticeDashboardWebPage from "./(web)";
import useNoticesQuery from "features/notice/hooks/queries/useNoticesQuery";
import { FormProvider, useForm } from "react-hook-form";
import NoticeDashboardMobilePage from "./(mobile)";
import removeEmptyFields from "utils/removeEmptyFields";
import dayjs from "dayjs";
import { useParamState } from "@yoonhaemin-lib/use-param-state";

export interface NoticeDashboardFormData {
  searchType: "author" | "title";
  search: string;
  startDate?: string;
  endDate?: string;
}

const NoticeDashboardPage = () => {
  const isSmall = useMediaView("small");
  const methods = useForm<NoticeDashboardFormData>({
    defaultValues: {
      searchType: "title",
      search: "",
      startDate: undefined,
      endDate: undefined,
    },
  });

  const [{ page, ...searchOption }, setSearchOption] = useParamState({
    searchType: "title",
    search: "",
    startDate: "" as string | undefined,
    endDate: "" as string | undefined,
    page: 1,
  });

  const { data: noticeData } = useNoticesQuery(
    removeEmptyFields({
      author:
        searchOption?.searchType === "author" ? searchOption.search : undefined,
      title:
        searchOption?.searchType === "title" ? searchOption.search : undefined,
      page: page - 1,
      size: 10,
      startDate:
        searchOption.startDate &&
        dayjs(searchOption.startDate).format("YYYY-MM-DD"),
      endDate:
        searchOption.endDate &&
        dayjs(searchOption.endDate).format("YYYY-MM-DD"),
    }),
  );

  const handleSearch = (data: NoticeDashboardFormData) => {
    setSearchOption((pre) => ({ ...pre, ...data }));
  };

  return (
    <form onSubmit={methods.handleSubmit(handleSearch)}>
      <FormProvider {...methods}>
        {!isSmall && (
          <NoticeDashboardWebPage
            data={noticeData.data.result}
            page={page}
            setSearchOptions={setSearchOption}
          />
        )}
        {isSmall && (
          <NoticeDashboardMobilePage
            data={noticeData.data.result}
            page={page}
            setSearchOptions={setSearchOption}
          />
        )}
      </FormProvider>
    </form>
  );
};

export default NoticeDashboardPage;
